/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
import { IGoogleReCaptchaConsumerProps, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { Button, Heading, Image, Stack, Text, useDisclosure } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { NavigateFunction, useLocation, useNavigate } from 'react-router-dom'
import Countdown from 'react-countdown'
import styled from 'styled-components'

import { isSuccessStatus } from 'utils/functions/validations'
import { returnSendEmailRecoveryPasswordErrorType } from 'services/returnApiType'
import { IReturnSendEmailRecoveryPasswordError } from 'services/IApi.d'
import plane from '../assets/images/plane.svg'
import tick from '../assets/images/tick.svg'
import { useSubscriberContext } from '../providers/SubscriberProvider'
import { InformativeLayer } from 'components/informativeLayer'
import IBalert from '../components/common/IBalert/IBalert'

const EmailValidationWrapper = styled.div``
const CountdownWrapper = styled.label``
const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: var(--chakra-space-40) !important;
`
const ResendLink = styled.div`
  margin-bottom: var(--chakra-space-8) !important;
`

interface EmailValidationProps { }

const EmailValidationPage: React.FC<EmailValidationProps> = () => {
  const navigate: NavigateFunction = useNavigate()
  const { executeRecaptcha }: IGoogleReCaptchaConsumerProps = useGoogleReCaptcha()
  const { state }: any = useLocation() || {}
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { pageBefore, userEmailFull } = state || {}
  const [pageStatus] = useState<string>(pageBefore || 'main')
  const [countdownKey, setCountdownKey] = useState<number>(0)
  const [startCountdown, setStartCountdown] = useState<number>(Date.now() + 900000)
  const [resendButton, setResendButton] = useState<boolean>(true)
  const {
    subscriberData: { email, document, documentForeign, lastName, nacionality, name, areaCode, documentType, phone, countryPhoneCode, codArea },
    resendValidationEmail,
    validateInSIB,
    subscriberData,
    sendValidationEmail,
    sendEmailRecoveryPassword,
  } = useSubscriberContext()
  const maskEmail = email => {
    if (!email) return email
    const [localPart, domain] = email.split('@')

    if (!domain) return email
    const maskedLocalPart = localPart.length > 5 ? localPart.slice(0, 5) + '*'.repeat(localPart.length - 5) : localPart

    return `${maskedLocalPart}@${domain}`
  }

  const userEmail = maskEmail(userEmailFull || email)

  const handleResendEmail = async () => {
    setResendButton(prevState => !prevState)
    setCountdownKey(prev => prev + 1)
    setStartCountdown(Date.now() + 900000)
    const subscriberDocument = documentType === 'cuil' ? document : documentForeign
    try {
      if (pageStatus !== 'recovery') {
        const recaptchaToken: string = await executeRecaptcha('lobby')
        const isSibResponse = await validateInSIB({
          documento: subscriberDocument,
          apellido: lastName,
          nacionalidad: nacionality,
          nombre: name,
          pais: areaCode,
          tipoDocumento: documentType === 'cuil' ? 'Documento' : 'PAS',
        }, recaptchaToken)
        const isSib: boolean = isSibResponse?.data?.existeSib
        if (isSib) throw Error('El usuario ya existe en SIB')
      }
      const recaptchaToken: string = await executeRecaptcha('resendSubscriptorEmail')
      let response
      if (pageStatus === 'recovery') {
        const typeDocument = documentType === 'cuil' || documentType === 'Documento Extranjero' ? 'Documento' : 'PAS'
        response = await sendEmailRecoveryPassword(typeDocument, subscriberData?.numberDocument, recaptchaToken, subscriberData?.nacionality)
        if (response.status === 409) {
          const sendEmailFail: IReturnSendEmailRecoveryPasswordError = response.data
          const sendEmailFailErr: returnSendEmailRecoveryPasswordErrorType = sendEmailFail.errors.shift().errorMessage
          navigate('/suscripcion/error-correo', { state: { pageBefore: 'recoveryUser409', messageType: sendEmailFailErr} })
          return
        }
      } else if (pageStatus === 'main') {
        const params = {
          nacionality,
          document,
          documentForeign,
          documentType,
          name,
          lastName,
          email,
          areaCode,
          codArea,
          phone,
          countryPhoneCode,
        }
        response = await sendValidationEmail(email, subscriberDocument, params, recaptchaToken, 'REGISTRO_SUSCRIPTOR')
      } else {
        response = await resendValidationEmail(email, subscriberDocument, recaptchaToken)
      }

      if (!isSuccessStatus(response.status)) {
        const options = pageStatus === 'recovery' ? { state: { pageBefore: 'recoveryUser500' } } : {}
        navigate('/suscripcion/error-correo', options)
      } else {
        onOpen()
      }
    } catch (error) {
      const options = pageStatus === 'recovery' ? { state: { pageBefore: 'recoveryUser500' } } : {}
      navigate('/suscripcion/error-correo', options)
    }
  }

  const textReturn = () => ({
    title: `Te enviamos un link de recuperación a  ${userEmail}`,
    subTitle: 'Recordá revisar la carpeta de spam.'
  })

  const countdown = ({ minutes, seconds }) => {
    const formattedMinutes: string = minutes < 10 ? `0${minutes}` : minutes
    const formattedSeconds: string = seconds < 10 ? `0${seconds}` : seconds
    return <span>{formattedMinutes}:{formattedSeconds}</span>
  }

  const changeResendButton: any = () => {
    setResendButton(prevState => !prevState)
  }

  useEffect(() => () => {
    window.history.replaceState({}, null)
  }, [])

  return (
    <EmailValidationWrapper>
      {pageStatus === 'verified' &&
        <InformativeLayer
          title={<Text>¡Verificaste tu email, tu cuenta está lista!</Text>}
          subtitle={<Text>Ahora solo debes iniciar sesión en la web de interbanking, puedes hacerlo clickeando en el botón de abajo</Text>}
          Image={<Image src={tick} />}
        />
      }
      {pageStatus === 'recovery' &&
        <Stack spacing={5} align='center' m={20}>
          <Image src={plane} />
          <Text maxW='500px' textStyle='h3'>
            {textReturn().title}
          </Text>
          <Text pt={6} >
            <span
              dangerouslySetInnerHTML={{__html: textReturn().subTitle}}
            />
          </Text>
          <BottomSection>
            <CountdownWrapper>
              <Text color='secondary.110' m='10'>
                El link enviado vencerá en&nbsp;
                <Countdown
                  key={countdownKey}
                  date={startCountdown}
                  renderer={countdown}
                  onComplete={changeResendButton}
                />
              </Text>
            </CountdownWrapper>
            <ResendLink>
              <Button color='primary.500' borderColor='primary.500' variant='primary-outline' disabled={resendButton} onClick={() => handleResendEmail()}>
                Reenviar link
              </Button>
            </ResendLink>
          </BottomSection>
          <IBalert
            type='success'
            isOpen={isOpen}
            onClose={onClose}
            title='Link reenviado'
            text='Revisá la bandeja de entrada de tu email.'
            variant='sm'
            buttonClose
            isIcon
          />
        </Stack>
      }
      {pageStatus === 'main' &&
        <Stack spacing={5} align='center' m={20}>
          <Image src={plane} />
          <Text textStyle='h3'>{`Te enviamos un link a ${email} para validar tu email`}</Text>
          <Text>Recordá revisar la casilla de spam</Text>
          <BottomSection>
            <CountdownWrapper>
              <Text color='secondary.110' textStyle='bodyMd' m='10'>
                El link enviado caducará en&nbsp;
                <Countdown
                  key={countdownKey}
                  date={startCountdown}
                  renderer={countdown}
                  onComplete={changeResendButton}
                />
              </Text>
            </CountdownWrapper>
            <ResendLink>
              <Button color='primary.500' borderColor='primary.500' variant='primary-outline' disabled={resendButton} onClick={() => handleResendEmail()}>
                Reenviar link
              </Button>
            </ResendLink>
          </BottomSection>
        </Stack>
      }
    </EmailValidationWrapper>
  )
}

export default EmailValidationPage
